<template>
  <v-container fluid>
    <LightSetting
      :locationIntegration="locationIntegration"
      :LocationId="LocationId"
    />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex"
import LightSetting from "./LightSetting"

export default {
  name: "location-expense",
  components: { LightSetting },
  props: {
    locationIntegration: {
      type: Object,
      required: true,
    },
    LocationId: {
      type: [Number, String],
      required: true,
    },
    location: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters("integration", ["locationModules", "modules"]),
  },
}
</script>